import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=b8958bfe&"
import script from "./CurrencyInput.vue?vue&type=script&lang=js&"
export * from "./CurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports